export default __webpack_public_path__ + "static/media/extendAccess.cb921742.svg";